import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import { isEmpty, map, size } from "lodash";
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody
} from "reactstrap"
import img1 from "../../assets/images/sidebar/img1.jpg"
import primg1 from "../../assets/images/no-img.jpg"
import heart from "../../assets/img/heart.png"
import greenHeart from "../../assets/img/green-heart.png"
import { getClientRecentActivities, getClientUpcomingActivities, getProjects } from "../../store/actions"
import Moment from 'react-moment';
import { API_URL } from "helpers/api_url";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

import { ensureValidToken, setupInactivityTimer } from "../../helpers/api_helper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';

class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
    this.toggleAllActivity = this.toggleAllActivity.bind(this);
  }
 toggleAllActivity(){
    this.setState({ activity: "",  isAllActivity: !this.state.isAllActivity });
 }
   fetchDeals(){
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
          Authorization: `Bearer ${token}`, 
          "Content-Type": "application/json",
        };
    
        const params = {
          clientId: localStorage.getItem("userId"),
          agentId: localStorage.getItem("agentId"),
        };
        axios
        .get(`${API_URL}ClientEngagement/all`, { headers, params })
        .then((response) => {
          this.setState({ deals: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
  componentDidMount() {

    setupInactivityTimer();
    
    ensureValidToken()
    .then(() => {
      const { onGetClientRecentActivities, onGetClientUpcomingActivities, onGetProject } = this.props;

      // Fetch data after validating the token
      onGetClientRecentActivities(localStorage.getItem("userId"), localStorage.getItem("agentId"));
      onGetClientUpcomingActivities(localStorage.getItem("userId"), localStorage.getItem("agentId"));
      onGetProject(localStorage.getItem("agentId"), localStorage.getItem("userId"));
      this.fetchActivities();
      this.fetchIntraction();
      this.fetchClientActivity();
      this.fetchClientUpcomingShowings();
      this.fetchDeals();
    })
    .catch((error) => {
      console.error("Error ensuring valid token:", error);
      localStorage.clear();
      window.location.href = "/login"; 
    });
}
fetchClientActivity(){
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
      Authorization: `Bearer ${token}`, 
      "Content-Type": "application/json",
    };
    const params = {
      agentId: localStorage.getItem("agentId"),
      clientId: localStorage.getItem("userId"),
    };
    axios
    .get(`${API_URL}ClientListingActivity/allforagent`, { headers, params })
    .then((response) => {
         const today = new Date();
         today.setHours(0, 0, 0, 0);
     const upcomingActivities = response.data.filter((activity) => {
        const activityDate = new Date(activity.clientListingActivityRefStartDate);
        activityDate.setHours(0, 0, 0, 0); 
        return activityDate >= today;
      });
      this.setState({ clientActivities: response.data, upcomingActivities:upcomingActivities, loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
}
getListingSubType = (type) => {
  if(type==1)
    return 'Listing Added';
  else if(type==2)
  return 'Scheduled';
  else if(type==3)
    return 'Re-scheduled Request';
  else if(type==5)
    return 'Message';
  else if(type==6)
    return 'Offer sent';
  else if(type==7)
    return 'Offer Accepted';
  else if(type==8)
    return 'Widthdrawn';
  else if(type==9)
    return 'Rejected';
}
getSellerListingSubType = (type) => {
  if(type==11)
    return 'Listing Added';
  else if(type==12)
  return 'Scheduled';
else if(type==13)
  return 'Showing Update';
  else if(type==16)
    return 'Offer Received';
  else if(type==17)
    return 'Offer Accepted';
  else if(type==18)
    return 'Widthdrawn';
  else if(type==19)
    return 'Rejected';
}
fetchClientUpcomingShowings(){
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
      Authorization: `Bearer ${token}`, 
      "Content-Type": "application/json",
    };
    const params = {
      agentId: localStorage.getItem("agentId"),
      clientId: localStorage.getItem("userId"),
    };
    axios
    .get(`${API_URL}ClientExt/allupcomingshowings`, { headers, params })
    .then((response) => {
      this.setState({ clientListings: response.data, loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
}
getBuyerType = (type) => {
  if (type == 1)
    return 'Rent';
  else if (type == 2)
    return 'Purchase';

}

getSellerType = (type) => {
  if (type == 1)
    return 'Sell';
  else if (type == 2)
    return 'Lease';

}
getCommType = (type) => {
  if (type == 3)
    return 'Fixed';
  else if (type == 4)
    return '%';

}
getType = (type) => {
  if(type==1)
    return 'Buyer';
  else if(type==2)
  return 'Seller';
  else if(type==3)
    return 'Openhouse';
}
getOpenHouse = (type) => {
  if(type==22)
    return 'Scheduled';
  else if(type==23)
    return 'Updated';
}
fetchActivities = async () => {
  //await ensureValidToken(); 
  const agentId = localStorage.getItem('agentId');
  const clientId = localStorage.getItem('userId');
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
};
try {
  const response = await axios.get(
    `${API_URL}ClientAppointment/getActivityListByClient?clientId=${clientId}&agentId=${agentId}&category=2`,
    { headers } // Passing headers
  );
  this.setState({ activitiesData: response.data });
} catch (error) {
  console.error("Error fetching data:", error);
}
};
fetchIntraction = async () => {
   const agentId = localStorage.getItem('agentId');
  const clientId = localStorage.getItem('userId');
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
};
try {
  const response = await axios.get(
    `${API_URL}ClientAppointment/getInterectionListByClient?clientId=${clientId}&agentId=${agentId}`,
    { headers } // Passing headers
  );
  this.setState({ intractionsData: response.data });
} catch (error) {
  console.error("Error fetching data:", error);
 
}
};

  handelFav = async (project) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
  };
  try {
    const payload = {
      clientId: parseInt(localStorage.getItem('userId')),
      agentId: parseInt(localStorage.getItem('agentId')),
      projectId: project.id,
      favouriteProjectDate: new Date(),
      isActive: true,
    }
    toast.loading("Please wait...");
    const response = await axios.post(
      `${API_URL}ClientBuyerFavouriteProject`,
        payload, 
      { headers }
    );
    if(response.data.success){
      const {onGetProject} = this.props;
      toast.dismiss();
      toast.success('Project Marked as Favourite'); 
      onGetProject(localStorage.getItem('agentId'), localStorage.getItem('userId'));
    }
  } catch (error) {
    console.error("Error posting data:", error);
  }
  }
  render() {
    const { uactivities, ractivities, projects } = this.props;
    const { deals } = this.state;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    return (
      <React.Fragment>
         <ToastContainer autoClose={2000} />
        <div className="page-content">
          <MetaTags>
            <title>Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid>
          
              <Row>
               <Col sm="8" className="d-flex">
                        <Card className="rs-card-bg w-100">
                          <CardBody className="d-flex flex-column">
               
           
                    <h5 className="card-title  mb-4 w-100">Upcoming Activity 


                      <span className="float-end">
                          <Link to="#" onClick={this.toggleAllActivity} className="btn btn-outline-secondary bt-for active">
                             <span className="d-flex align-items-center gap-2">
                               All Activity
                                
                               </span>
                      </Link>
                      </span>
                    </h5>
                    <div className="datatable-loading">
                                                <DataTable
                                                  className=""
                                                  stripedRows
                                                  value={this.state.upcomingActivities || []}
                                                  paginator
                                                  rows={5}
                                                  rowsPerPageOptions={[5, 10, 20, 30, 50, 100, 150, 200, 500]}
                                                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                                  tableStyle={{ minWidth: "50rem" }}
                                                >
                                                  <Column
                                                    headerClassName="header-bg-table"
                                                    field="showingDate"
                                                    header="Date"
                                                    body={(rowData) =>
                                                      rowData.addedDate			 ? <Moment format="DD MMM, YYYY">{rowData.addedDate		}</Moment> : "N/A"
                                                    }
                                                  />
                    
                                                  <Column
                                                    headerClassName="header-bg-table"
                                                    field="clientListingActivityListing"
                                                    header="Listing Id"
                                                    body={(rowData) => (
                                                      <>
                                                        {rowData.clientListingActivityListing}{" "}
                                                        {rowData.clientListingActivityListingPublicURL && (
                                                          <a
                                                            href={rowData.clientListingActivityListingPublicURL}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="font-size-18"
                                                            style={{verticalAlign:'middle'}}
                                                          >
                                                            <i className="bx bx-link-external"></i>
                                                          </a>
                                                        )}
                                                      </>
                                                    )}
                                                  />
                                                
                                                  <Column  headerClassName="header-bg-table" field="clientListingActivityListingAddress" header="Listing Address" body={(rowData) => rowData.clientListingActivityListingAddress} />
                                                <Column 
                                                    headerClassName="header-bg-table"
                                                    field="clientListingActivitySubType" 
                                                    header="Type" 
                                                    body={(rowData) => {
                                                      const type = rowData.clientListingActivityType;
                                                      const subType = rowData.clientListingActivitySubType;
                                                      const prefix = this.getType(type) + "-";

                                                      if (type === 1) {
                                                        return prefix + (this.getListingSubType(subType) || "N/A");
                                                      } else if (type === 2) {
                                                        return prefix + (this.getSellerListingSubType(subType) || "N/A");
                                                      } else {
                                                        return prefix + (this.getOpenHouse(subType) || "N/A");
                                                      }
                                                    }}
                                                  />
                                                {/* <Column 
                                              headerClassName="header-bg-table"
                                              field="clientListingActivitySubType" 
                                              header="Sub Type" 
                                              body={(rowData) => {
                                                const type = rowData.clientListingActivityType;
                                                const subType = rowData.clientListingActivitySubType;

                                                if (type === 1) {
                                                  return this.getListingSubType(subType) || "N/A";
                                                } else if (type === 2) {
                                                  return this.getSellerListingSubType(subType) || "N/A";
                                                } else {
                                                  return this.getOpenHouse(subType) || "N/A";
                                                }
                                              }}
                                            /> */}
                                                
                                                </DataTable>
                                              
                                                </div>
				</CardBody>
        </Card>
	            

            </Col>
              <Col sm="4"className="d-flex">
              <Card className="rs-card-bg w-100">
                <CardBody className="d-flex flex-column">
                    <h5 className="card-title w-100  mb-4">Current Deals <Link to={`/deals`} className="float-end">Go to Deals</Link></h5>
                     <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      <table className="table  mb-0">
                        <thead className="sticky-top">

  <tr>
  <th>Start date</th>
  <th>Type</th>
  
  <th>Amount</th>
  
  
  </tr>

</thead>
<tbody>
{deals && deals
  .filter(deal => deal.clientEngagementStatus === 1)
  .map((deal, index) => (
    <tr key={index}>
      <td><Moment format="DD MMM, YYYY">{deal.lastAgreementDate}</Moment></td>
      <td>
        {(() => {
          if (deal.isBuyer) {
            return `Buyer${deal.buyerType ? ` - ${this.getBuyerType(deal.buyerType)}` : ""}`;
          }
          if (deal.isSeller) {
            return `Seller${deal.sellerType ? ` - ${this.getSellerType(deal.sellerType)}` : ""}`;
          }
          if (deal.isInvestor) {
            return "Investor";
          }
          return "N/A";
        })()}
      </td>
      <td>${deal?.transactionAmount?.toFixed(2) || "0.00"}</td>
    </tr>
))}
</tbody>
                      </table>
              </div>
               </CardBody>
                    </Card>
              </Col>
     {/* <Col sm="4" className="d-flex">
                        <Card className="rs-card-bg w-100">
                          <CardBody className="d-flex flex-column">
                    <h5 className="card-title mb-4">Upcoming showings   Next 7 days</h5>
                    <div className="table-responsive" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      <table className="table  mb-0">
                        <thead className="sticky-top">
							  <tr>
								<th>Date</th>
								<th>Time</th>
								
                <th>Listing</th>
                <th>Address</th>
                <th>Type</th>
                <th>Route plan</th>
                
							  </tr>
							</thead>
							<tbody>
              {this.state.clientListings && this.state.clientListings.map((listing, index) => (
                <tr key={index}>
                  <td><Moment format="DD MMM, YYYY">{listing.showingDate}</Moment></td>
                  <td><Moment format="hh:mm A">{listing.startTime}</Moment></td>
                  <td>{listing.mlsId}</td>
                  <td>{listing.listingAddress}</td>
                  <td></td>
                  <td>{listing.routeInfo ? 'Set' : 'Not Set' }</td>
                </tr>
              ))}
							</tbody>
						        </table>
                    </div>
                    </CardBody>
                    </Card>
              </Col>
             */}
                            

            </Row>
           
            <Row>
           
             
                
          
             
            </Row>
           
          

            <h4 className="mb-4">Pre-construction Projects</h4>
            <Row>
                {map(projects, (project, projectkey) => (
                  <Col sm="3" key={"_note_" + projectkey}>
                    <div className="product">
                    <div className="project-satatus">
                      <span>{localization["ProjectStatus_"+ project.projectStatus]}</span>
                  </div>
                   <div className="icon-check">
                    {project.isMarkedFavouriteByClient ? (
                      <img src={greenHeart} style={{width:30, cursor:'pointer'}}  />
                    ) : (
                      <img onClick={()=>this.handelFav(project)} src={heart} style={{width:30, cursor:'pointer'}}  />
                     
                    )}
                   
                    </div>
                    <Link to={"/project-detail/" + project.id + "/" + project.preConsProjectGuid}>
                   
                        <div className="pro-img minHeight">
                        {project.projectMainImage != null 
                          ? <img src={project?.projectMainImage?.projectGalleryLink} style={{width:300}} className="img-fluid" />
                          : <img src={primg1} style={{width:300}} className="img-fluid" />
                        }
                        </div>
                    </Link>
                      <div className="bg-transparent border-top card-footer"><div className="contact-links d-flex"><div className="flex-fill font-size-14">{project.city}</div><div className="float-end"><Link to={"/project-detail/" + project.id + "/" + project.preConsProjectGuid}> {project.projectName} </Link></div></div></div>
                        
                    </div>

                  </Col>
                ))}
              </Row>     
        
            

          </Container>
        </div>
                            <Offcanvas
                              isOpen={this.state.isAllActivity}
                              direction="end"
                              toggle={this.toggleAllActivity}
                              style={{width:950}}
                            >
                              <OffcanvasHeader toggle={this.toggleAllActivity}>
                                All Activity 
                              </OffcanvasHeader>
                              <OffcanvasBody>
                                   <DataTable
                                                  className=""
                                                  stripedRows
                                                  value={this.state.clientActivities || []}
                                                  paginator
                                                  rows={10}
                                                  rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                                                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                                  tableStyle={{ minWidth: "50rem" }}
                                                >
                                                  <Column
                                                    headerClassName="header-bg-table"
                                                    field="showingDate"
                                                    header="Date"
                                                    body={(rowData) =>
                                                      rowData.addedDate			 ? <Moment format="DD MMM, YYYY">{rowData.addedDate		}</Moment> : "N/A"
                                                    }
                                                  />
                    
                                                  <Column  headerClassName="header-bg-table" field="clientListingActivityListing" header="Listing Id" body={(rowData) => rowData.clientListingActivityListing || "N/A"} />
                                                
                                                  <Column  headerClassName="header-bg-table" field="clientListingActivityListingAddress" header="Listing Address" body={(rowData) => rowData.clientListingActivityListingAddress} />
                                                <Column 
                                                    headerClassName="header-bg-table"
                                                    field="clientListingActivitySubType" 
                                                    header="Type" 
                                                    body={(rowData) => {
                                                      const type = rowData.clientListingActivityType;
                                                      const subType = rowData.clientListingActivitySubType;
                                                      const prefix = this.getType(type) + "-";

                                                      if (type === 1) {
                                                        return prefix + (this.getListingSubType(subType) || "N/A");
                                                      } else if (type === 2) {
                                                        return prefix + (this.getSellerListingSubType(subType) || "N/A");
                                                      } else {
                                                        return prefix + (this.getOpenHouse(subType) || "N/A");
                                                      }
                                                    }}
                                                  />
                                            
                                                
                                                </DataTable>

                              </OffcanvasBody>
                              </Offcanvas>
      </React.Fragment>
    )
  }
}
Dashboard.propTypes = {
  t: PropTypes.any,
  onGetClientLists:PropTypes.func,
  onGetClientRecentActivities:PropTypes.func,
  onGetClientUpcomingActivities:PropTypes.func,
  uactivities:PropTypes.array,
  ractivities:PropTypes.array,
  onGetProject:PropTypes.func,
  projects:PropTypes.array,
}
const mapStateToProps = ({ Dashboard, projects }) => (
  {
      
      uactivities:Dashboard.uactivities,
      ractivities:Dashboard.ractivities,
      projects:projects.projects

  })
const mapDispatchToProps = dispatch => ({
  onGetClientLists: agentID => dispatch(getClientList(agentID)),
  onGetClientRecentActivities: (clientId,agentId) => dispatch(getClientRecentActivities(clientId,agentId)),
  onGetClientUpcomingActivities: (clientId,agentId) => dispatch(getClientUpcomingActivities(clientId,agentId)),
  onGetProject:(agetnId, clientId) => dispatch(getProjects(agetnId, clientId))
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Dashboard))
